export default __webpack_public_path__ + "static/media/Agilis.1f168635.jpg";